import powerBiReportsService from 'src/services/powerBiReports'

// Promise en vuelo — evita requests duplicados cuando MainLayout y
// PowerBiReportsPage llaman fetchReports casi al mismo tiempo. Vive fuera
// del state (no reactivo) porque un Promise nativo envuelto en el Proxy
// reactivo de Pinia rompe su .then() en varios motores.
let fetchPromise = null

export default {
  fetchReports () {
    if (this.hasFetched) return Promise.resolve()
    if (fetchPromise) return fetchPromise

    this.isLoading = true
    this.hasError = false
    fetchPromise = powerBiReportsService.getReports()
      .then(({ data }) => {
        this.reports = data.reports
        this.aad = data.aad ?? { tenantId: null, clientId: null }
        this.hasFetched = true
      })
      .catch(error => {
        console.error(error)
        this.hasError = true
      })
      .finally(() => {
        this.isLoading = false
        fetchPromise = null
      })

    return fetchPromise
  },
  async fetchEmbedToken (reportId) {
    const { data } = await powerBiReportsService.getEmbedToken(reportId)
    return data
  }
}
